import { render, staticRenderFns } from "./MixCarrierCancelModal.vue?vue&type=template&id=b0721358&"
import script from "./MixCarrierCancelModal.vue?vue&type=script&lang=js&"
export * from "./MixCarrierCancelModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports